import { __read } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { ConnectSymbol } from './Connectable';
import { PortalManagerProvider } from './context';
import { RcPortalRenderer } from './PortalRenderer';
var RcPortalHost = function (_a) {
    var manager = _a.manager;
    var _b = __read(useState([]), 2), portals = _b[0], setPortals = _b[1];
    // prevent manager change
    var managerRef = useRef(manager);
    useEffect(function () {
        var disconnectHandler = managerRef.current[ConnectSymbol](function (portalDescriptors) {
            setPortals(portalDescriptors);
        });
        return disconnectHandler;
    }, []);
    return (React.createElement(PortalManagerProvider, { value: managerRef.current }, portals.map(function (portal) { return (React.createElement(RcPortalRenderer, { key: portal.id, portalDescriptor: portal })); })));
};
RcPortalHost.displayName = 'RcPortalHost';
export { RcPortalHost };
